import { Button, Modal, Table } from 'antd';
import React, { Dispatch, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';
import { ApplicationState } from '../../../../store';
import { cleanDetalhesNota } from '../../../../store/ducks/solicitacoesRetorno/actions';
import { loadRequest as itensNotaRequest } from '../../../../store/ducks/solicitacoesRetornoItensNota/actions';
import { ItensNotaProps } from './props';
import { CloseOutlined } from '@ant-design/icons';
import CardMobile from './CardMobile';
import { useWindowSize } from '../../../../hook/useWindowSize';
import { maskCurrency, maskUnd } from '../../../../utils/mask';
import { Container } from './styles';

const ModalSolicitacoesRetorno: React.FC<ItensNotaProps> = ({ text, nuNota, chave = '' }) => {
  const loadingItensNota = useSelector(
    (state: ApplicationState) => state.SolicitacoesRetorno.loading
  );
  const itensNota = useSelector(
    (state: ApplicationState) => state.SolicitacoesRetornoItensNota.data
  );
  const [isModalVisible, setIsModalVisible] = useState(false);
  const dispatch = useDispatch<Dispatch<Action>>();
  const { width }: any = useWindowSize();

  const handleCancel = () => {
    setIsModalVisible(false);
    dispatch(cleanDetalhesNota());
  };

  const showModal = () => {
    setIsModalVisible(true);
    dispatch(itensNotaRequest(nuNota));
  };

  const columns = [
    {
      title: 'Código produto',
      dataIndex: 'codProduto',
      key: 'codProduto',
    },
    {
      title: 'Código referência',
      dataIndex: 'referencia',
      key: 'referencia',
    },
    {
      title: 'Produtos',
      dataIndex: 'descricaoProduto',
      key: 'descricaoProduto',
    },
    {
      title: 'Lote',
      dataIndex: 'controle',
      key: 'controle',
    },
    {
      title: 'Quantidade',
      dataIndex: 'quantidade',
      key: 'quantidade',
      classname: 'tablePedidos',
      render: (text: number = 0) => {
        return maskUnd(text);
      },
    },
    {
      title: 'Unidade',
      dataIndex: 'volume',
      key: 'volume',
      classname: 'tablePedidos',
    },
    {
      title: 'Peso bruto',
      dataIndex: 'pesoBruto',
      key: 'pesoBruto',
      render: (text: number) => {
        return maskUnd(text) + ' KG';
      },
    },
    {
      title: 'Valor total',
      dataIndex: 'valorTotal',
      key: 'valorTotal',
      render: (text: number = 0) => {
        return maskCurrency(text);
      },
    },
  ];

  return (
    <>
      <Container>
        <Modal
          centered
          title={`Lista de produtos - NF-${text} ${chave ? '- Chave da nota: ' + chave : ''}`}
          visible={isModalVisible}
          onCancel={handleCancel}
          onOk={handleCancel}
          maskClosable={true}
          closable={true}
          destroyOnClose={true}
          closeIcon={<CloseOutlined />}
          keyboard={true}
          width={1300}
          footer={
            <Button onClick={handleCancel} type="primary">
              Fechar
            </Button>
          }
        >
          {width > 768 && (
            <Table
              style={{ fontSize: 10, display: 'inline', width: '100%' }}
              scroll={{ x: 1200 }}
              columns={columns}
              size={'large'}
              pagination={{
                defaultPageSize: 3,
                defaultCurrent: 1,
                showSizeChanger: true,
                pageSizeOptions: ['3', '5', '10', '20', '50'],
              }}
              dataSource={itensNota}
              loading={loadingItensNota}
              className="table"
              rowKey={'nuNota'}
            />
          )}
          {width <= 768 && <CardMobile />}
        </Modal>
        <button
          style={{
            border: 'none',
            background: 'none',
            color: '#1890ff',
            cursor: 'pointer',
            padding: '0',
          }}
          onClick={() => showModal()}
        >
          {text}
        </button>
      </Container>
    </>
  );
};

export default ModalSolicitacoesRetorno;
